export default __webpack_public_path__ + "static/21-cyberspace-98111a1396295ac8c871f3cf72859560.png";